import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "milestone-stage-status-selector" }
const _hoisted_2 = { class: "milestone-stage-status-selector__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MilestoneStageStatusItem = _resolveComponent("MilestoneStageStatusItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stageStatus, (status, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "milestone-stage-status-selector__item"
        }, [
          _createVNode(_component_MilestoneStageStatusItem, {
            active: index === _ctx.activeState,
            icon: status.icon,
            title: status.title,
            onStatusClick: ($event: any) => (_ctx.clickStageStatusHandler(status.title, index))
          }, null, 8, ["active", "icon", "title", "onStatusClick"]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "milestone-stage-status-selector__arrow" }, null, -1))
        ]))
      }), 128))
    ])
  ]))
}